import React from 'react';
import Header from '../../elements/header/Header';
import Hero from '../../elements/hero/Hero';
import MeetPlatform from '../../elements/meet-platform/MeetPlatform';
import WhatIsIt from '../../elements/what-is-it/WhatIsIt';
import WhatToDo from '../../elements/what-to-do/WhatToDo';
import LandingCourses from '../../elements/landing-courses/LandingCourses';
import LandingFooter from '../../elements/landing-footer/LandingFooter';
import './landing-page.css';

const Landing = () => {
  return (
    <>
      <Header />
      <main className='main-landing'>
        <Hero />
        <WhatIsIt />
        <WhatToDo />
        <MeetPlatform />
        <LandingCourses />
      </main>
      <LandingFooter />
    </>
  );
}

export default Landing;